import { render } from "./AssistantIcon.vue?vue&type=template&id=17d22daa&scoped=true"
import script from "./AssistantIcon.vue?vue&type=script&lang=js"
export * from "./AssistantIcon.vue?vue&type=script&lang=js"

import "./AssistantIcon.vue?vue&type=style&index=0&id=17d22daa&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17d22daa"],['__file',"src/components/ChatWidget/ChatAssistant/AssistantIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "17d22daa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('17d22daa', __exports__)) {
    api.reload('17d22daa', __exports__)
  }
  
  module.hot.accept("./AssistantIcon.vue?vue&type=template&id=17d22daa&scoped=true", () => {
    api.rerender('17d22daa', render)
  })

}


export default __exports__